import Marquee from "react-fast-marquee";

export const EditorialMarquee = () => {
  return (
    <section className="py-10 md:py-16 border-y border-white/10 bg-[#0A0A0A] overflow-hidden" aria-hidden="true">
      <Marquee speed={40} gradient={false}>
        {Array.from({ length: 6 }).map((_, i) => (
          <span key={i} className="font-serif-display text-6xl md:text-8xl text-stroke-gold mx-8 italic tracking-tight">
            El Japonais ·
          </span>
        ))}
      </Marquee>
    </section>
  );
};
